<div class="layout-topbar">

	<div class="topbar-left">
		<a href="#" class="layout-menu-button layout-topbar-icon" style="color: #1D2355"
			(click)="app.onMenuButtonClick($event)">
			<i class="pi pi-bars"></i>
		</a>
		<img src="../assets/layout/images/Logo_Marca.webp"
			style=" padding-left: 1%; width: 15vw; height: 98%">

	</div>
	<div  class="toolbar-saci">
		<button *ngIf="app.sacim === true" class="btn-saci-b2b fade-in" (click)="app.irA('b2b')">
		  <div class="icon-container">
			<img src="../assets/layout/images/4.png" alt="B2B Icon"
			>
		  </div>
		  <span class="text">SaciB2B</span>
		</button>
		<!-- <button class="btn-saci-b2b fade-in" (click)="app.irA('mautic')">
			<div class="icon-container">
			  <img src="../assets/layout/images/3.png" alt="B2B Icon"
			  >
			</div>
			<span class="text">Mautic</span>
		  </button> -->
		  <button *ngIf="app.sacim === true" class="btn-saci-b2b fade-in" (click)="app.irA('firmas')">
			<div class="icon-container">
			  <img src="../assets/layout/images/1.png" alt="B2B Icon"
			  
			  >
			</div>
			<span class="text">Firmas P12</span>
		  </button>
	  </div>
	  
	<!-- <div class="toolbar-saci">
		
		<button class="btn-saci-b2b">
		<img src="../assets/layout/images/1.png" class="icono">
		 <span>SaciB2B</span> 
		</button>
		<button class="btn-saci-b2b">
			Mauitic
		  </button>
		  <button class="btn-saci-b2b">
			Firmas
		  </button>
	  </div> -->
	  
<!--	<div class="navbar-container">
		 <button class="btn-saci">
		  SaciB2B
		</button>
		<button class="btn-saci">
			Mauitic
		  </button>
		  <button class="btn-saci">
			Firmas
		  </button>
	</div> -->
	  
	<!-- <div class="topbar-center">
		<img
		#btnb2b
		src="../assets/layout/images/4.png"
			class="img-btn"
			(mouseenter)="app.onHover(btnb2b)"
			(mouseleave)="app.onLeave(btnb2b)"
			(click)="app.irA('b2b')"
			data-hover="../assets/layout/images/1.png"
			data-normal="../assets/layout/images/4.png"
			>
			
		<img
		#btnmauitic
		src="../assets/layout/images/5.png"
			class="img-btn"
			(mouseenter)="app.onHover(btnmauitic)"
			(mouseleave)="app.onLeave(btnmauitic)"
			(click)="app.irA('mauitic')"
			data-hover="../assets/layout/images/2.png"
			data-normal="../assets/layout/images/5.png"
			>
		<img
		#btnfirmas
		src="../assets/layout/images/6.png"
			class="img-btn"
			(mouseenter)="app.onHover(btnfirmas)"
			(mouseleave)="app.onLeave(btnfirmas)"
			(click)="app.irA('firmas')"
			data-hover="../assets/layout/images/3.png"
			data-normal="../assets/layout/images/6.png"
			>			
			
	</div> -->
	<div class="topbar-right">
		<i class="pi pi-user"></i>
		<span class="guest-sign-in" style="color: #1D2355; font-weight: bold ">
			{{usuario.nombre + ' ' + usuario.apellido}}</span>
		<img src="{{logotipo}}" style=" width: 15vw; height: 98%">
	</div>
	
</div>